module.exports = __webpack_public_path__ + "static/media/SampleFile.d032dd58.xlsx";